interface RedoIconProps extends React.ComponentPropsWithRef<'svg'> {
  color?: string;
}

export function RedoIcon({ color = 'currentColor', ...svgProps }: RedoIconProps) {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M12.1465 0.646652C12.3173 0.47585 12.5813 0.454083 12.7754 0.582199L12.8535 0.646652L15.8535 3.64665C15.8873 3.68049 15.9134 3.71911 15.9355 3.75896C15.9601 3.80315 15.98 3.85041 15.9902 3.90154C16.0032 3.96627 16.0031 4.03306 15.9902 4.09782C15.9801 4.14902 15.96 4.19612 15.9355 4.2404C15.9134 4.28057 15.8876 4.31961 15.8535 4.35368L12.8535 7.35368C12.6583 7.54895 12.3417 7.54895 12.1465 7.35368C11.9513 7.15842 11.9512 6.8419 12.1465 6.64665L14.293 4.50017L5.5 4.50017C4.59052 4.50017 3.4544 4.78693 2.55762 5.48747C1.68029 6.17288 1.00003 7.2774 1 9.00017C1 10.723 1.6803 11.8274 2.55762 12.5129C3.4544 13.2134 4.5905 13.5002 5.5 13.5002L10.5 13.5002C10.7761 13.5002 10.9999 13.7241 11 14.0002C11 14.2763 10.7761 14.5002 10.5 14.5002L5.5 14.5002C4.40953 14.5002 3.04558 14.1618 1.94238 13.3C0.819801 12.4229 0 11.0273 0 9.00017C2.80253e-05 6.97311 0.819795 5.57743 1.94238 4.70036C3.04557 3.83852 4.40955 3.50017 5.5 3.50017L14.293 3.50017L12.1465 1.35368L12.082 1.27556C11.9539 1.08149 11.9756 0.817495 12.1465 0.646652Z"
        fill={color}
      />
    </svg>
  );
}
